// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { promotionCodeFormStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPromotionCode";
import IconX from "@pace/XDL/Icons/IconX";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { createLinkIconStyles } from "@pace/XDL/Utilities";
import { css } from "styled-components";

promotionCodeFormStyles.form = {
    css: css`
        margin-bottom: 20px;
    `,
};

promotionCodeFormStyles.applyButton = {
    variant: "primary",
    css: css`
        width: 100%;
        margin-top: 22px;
    `,
};

promotionCodeFormStyles.removeCodeTag = {
    typographyProps: {
        ellipsis: true,
        css: css`
            width: 100%;
            text-align: left;
            margin: 0;
        `,
    },
};

promotionCodeFormStyles.promotionRemovedText = {
    size: 14,
    weight: fontConfig.weight.semiBold,
};

promotionCodeFormStyles.applySuccessText = {
    size: 14,
    weight: fontConfig.weight.semiBold,
    color: "success",
};

promotionCodeFormStyles.removeCodesGridItem = {
    width: [12, 12, 12, 12, 12],
    css: css`
        justify-content: flex-end;
    `,
};

promotionCodeFormStyles.removeCodesLink = {
    ...createLinkIconStyles(IconX),
};
